import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AsideCollapseService {

    isAsideMenuCollapsed$: Observable<boolean>;
    isAsideMenuCollapsedSubject: BehaviorSubject<boolean>;
    
    constructor() {
        this.isAsideMenuCollapsedSubject = new BehaviorSubject<boolean>(false);
        this.isAsideMenuCollapsed$ = this.isAsideMenuCollapsedSubject.asObservable();
    }
}
